// extracted by css-extract-rspack-plugin
export default {"heading":"xbnHDvRgm85rJ4zc","paragraph":"vFUEJYOBWIktxK4H","featureList":"zp0iqJQRXA4WXVQr","item":"_CHUida2vjsiNG0V","checkmark":"yg2X9KzGXu8hSbRk"};